import useSession from 'components/auth/useSession'
import { PageLoading } from 'components/loading'
import { useAtendimentoViewQuery } from 'graphql/hooks.generated'
import React from 'react'
import { useParams } from 'react-router'
import { Redirect } from 'react-router-dom'

import { AtendimentoIndividualView } from '../atendimento-individual/AtendimentoIndividualView'
import { AtendimentoVacinacaoView } from '../atendimento-vacinacao/AtendimentoVacinacaoView'
import { EscutaInicialView } from '../escuta-inicial/EscutaInicialView'

interface AtendimentoViewParams {
  atendimentoId: string
}

export function AtendimentoView() {
  const { atendimentoId } = useParams<AtendimentoViewParams>()
  const { data, loading } = useAtendimentoViewQuery({ variables: { id: atendimentoId } })
  const { data: sessao } = useSession()

  if (loading) {
    return <PageLoading message='Carregando atendimento...' />
  } else if (!data?.atendimento.atendimentoProfissional) {
    return <Redirect to='/404' />
  } else if (data?.atendimento.atendimentoProfissional.lotacao.id !== sessao?.acesso.id) {
    return <Redirect to='/403' />
  } else if (data?.atendimento.atendimentoProfissional?.tipo === 'ESCUTA_INICIAL') {
    return <EscutaInicialView atendimentoId={atendimentoId} />
  } else if (data?.atendimento.atendimentoProfissional?.tipo === 'VACINACAO') {
    return <AtendimentoVacinacaoView atendimentoId={atendimentoId} />
  } else {
    return <AtendimentoIndividualView atendimentoId={atendimentoId} />
  }
}
